<!--
@if (svgUrl.hasValue() && svgUrl.value(); as src) {
  <object [data]="src" type="image/svg+xml" width="100%">svg</object>
}
-->


@switch (mode()) {
  @case ('thumbnail') {
    <i class="fa fa-image"></i>
  }
  @case ('view') {
    <img [src]="getUrl()" class="img-fluid w-100" [alt]="asset().displayName"/>
  }
  @case ('details') {
    <section>
      <h4>Example body</h4>
      <pre>{{ asset().exampleBody }}</pre>
    </section>
  }
}
